<template>
  <b-overlay :show="loading" class="animated">
    <v-server-table
      :columns="table_config.columns"
      :options="table_config.options"
      :theme="theme"
      :ref="ref"
      id="managed-lists-server-table"
      class="w-100"
    >
      <span slot="list" slot-scope="{ row }">
        <a :href="`#/managed-lists/${row.id}`" class="btn-link">
          {{ row.description }}
        </a>
      </span>

      <span slot="attributes" slot-scope="{ row }">
        {{ row.attribute_lists.length }}
      </span>
    </v-server-table>
  </b-overlay>
</template>

<script>
import Vue from "vue";
import { ServerTable } from "vue-tables-2";
import BaseServerTable from "@/components/shared/BaseServerTable";

Vue.use(ServerTable);

export default {
  name: "ManagedListsServerTable",
  extends: BaseServerTable,
  components: {
    ServerTable
  },
  props: {
    collection: {
      default: () => null
    },
    show_columns: {
      type: Array,
      default: () => ["list", "attributes"]
    },
    sortable: {
      type: Array,
      default: () => ["list"]
    },
    filterable: {
      type: Array,
      default: () => ["searchable"]
    },
    skip_filter_reset: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      table_config: Object.assign(this.getDefaultTableConfig(), {
        options: {
          headers: {
            list: "List",
            parent: "Parent List",
            attribute_lists: "Attributes"
          },
          filterable: this.filterable,
          sortable: this.sortable
        }
      })
    };
  }
};
</script>
